import { __decorate, __metadata } from "tslib";
import { containerResolver } from '../protocol/resolver';
import { Strategy } from '../types';
export { Strategy };
var StrategyResolver = /** @class */ (function () {
    /**
     * Creates an instance of the StrategyResolver class.
     * @param strategy The type of resolution strategy.
     * @param state The state associated with the resolution strategy.
     */
    function StrategyResolver(strategy, state) {
        this._resolved = false;
        this.strategy = strategy;
        this.state = this.originalState = state;
    }
    StrategyResolver_1 = StrategyResolver;
    /**
     * Called by the container to allow custom resolution of dependencies for a function/class.
     * @param container The container to resolve from.
     * @param key The key that the resolver was registered as.
     * @return Returns the resolved object.
     */
    StrategyResolver.prototype.get = function (container, key) {
        switch (this.strategy) {
            case Strategy.Instance:
                return this.state;
            case Strategy.Singleton:
                if (this._resolved)
                    return this.state;
                var singleton = container.invokeWithKey(this.state, key);
                this.state = singleton;
                this._resolved = true;
                return singleton;
            case Strategy.Scoped:
                if (this._resolved)
                    return this.state;
                var scoped = container.invokeWithKey(this.state, key);
                this.state = scoped;
                this._resolved = true;
                return scoped;
            case Strategy.Transient:
                return container.invokeWithKey(this.state, key);
            case Strategy.Function:
                return this.state(container, key, this);
            case Strategy.Array:
                return this.state[0].get(container, key);
            case Strategy.Alias:
                return container.get(this.state);
            default:
                throw new Error('Invalid strategy: ' + this.strategy);
        }
    };
    StrategyResolver.prototype.clone = function () {
        return new StrategyResolver_1(this.strategy, this.originalState);
    };
    var StrategyResolver_1;
    StrategyResolver = StrategyResolver_1 = __decorate([
        containerResolver,
        __metadata("design:paramtypes", [Number, Object])
    ], StrategyResolver);
    return StrategyResolver;
}());
export { StrategyResolver };
//# sourceMappingURL=data:application/json;base64,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